// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Bazar";
export const FROM_SELLER = "Od prodejkyn\u011b";
